// Styles import
import './styles/globals.css';

// Components
export { CustomTable } from './components/CustomTable';
export { Pagination } from './components/CustomTable/Pagination';
export { checkboxColumn, actionColumn } from './components/CustomTable/DefaultColumns';

// Utils
export { cn } from './lib/utils';

// Types
export type { 
  ColumnDef,
  ColumnFiltersState,
  SortingState,
  VisibilityState,
  Table,
  PaginationState,
} from '@tanstack/react-table'; 

export type {
  CalendarProps
} from './lib/types/calendar.types';

export type {
  CustomTableProps
} from './lib/types/table.types';


